import api from "../api"
import { saveAs } from 'file-saver'

export const ACTION_TYPES = {
    CLEAN_USER_PROFILE: 'CLEAN_USER_PROFILE',
    FETCH_DASHBOARD: 'FETCH_DASHBOARD',
    FETCH_OC_BY_STATUS: 'FETCH_OC_BY_STATUS',
    FETCH_FILTER_BY_DATE: 'FETCH_FILTER_BY_DATE',
    FETCH_FILTER_BY_TEXT: 'FETCH_FILTER_BY_TEXT',
    FETCH_EVIDENCE: 'FETCH_EVIDENCE',
    FETCH_ORDER_DETAIL: 'FETCH_ORDER_DETAIL',
    FETCH_INVOICE_HISTORY: 'FETCH_INVOICE_HISTORY',
    RESULT_UPLOAD_INVOICE: 'RESULT_UPLOAD_INVOICE',
    RESULT_UPLOAD_COMPLEMENT: 'RESULT_UPLOAD_COMPLEMENT',
    FETCH_INVOICE_COMPLEMENT: 'FETCH_INVOICES_COMPLEMENT',
    FETCH_REJECTED_INVOICE: 'FETCH_REJECTED_INVOICE',
    FETCH_WORK_ORDER_DETAIL: 'FETCH_WORK_ORDER_DETAIL',
    FETCH_SUBSTAGE_PER_ORDER: 'FETCH_SUBSTAGE_PER_ORDER',
    FETCH_SUBSTAGE: 'FETCH_SUBSTAGE',
    FETCH_RIGTHS_PER_ORDER: 'FETCH_RIGTHS_PER_ORDER',
    FETCH_RIGTHS: 'FETCH_RIGTHS',
    FETCH_SUBSTAGE_PER_ORDER_API: 'FETCH_SUBSTAGE_PER_ORDER_API',
    FETCH_RIGTHS_PER_ORDER_API: 'FETCH_RIGTHS_PER_ORDER_API',
    CHANGE_STATE: 'CHANGE_STATE',
    FETCH_COMMENTS: 'FETCH_COMMENTS',
    POST_COMMENTS_API: 'POST_COMMENTS_API',
    FETCH_ERRORS: 'FETCH_ERRORS',
    FETCH_STATE_PLATE: 'FETCH_STATE_PLATE',
    FETCH_TYPE_PLATE: 'FETCH_TYPE_PLATE',
    FETCH_WOPROCEDURE_PLATE: 'FETCH_WOPROCEDURE_PLATE'
}

export const fetch_Dashboard = (lang, token, supplierId, onError, onSuccess) => dispatch => {
    api.Collateral().fetchDashboard(lang, token, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_DASHBOARD,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_oc_by_status = (lang, token, branchOfficeId, stage, onError, onSuccess) => dispatch => {
    api.Collateral().fetchOCByStatus(lang, token, branchOfficeId, stage)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_OC_BY_STATUS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_oc_by_filter = (lang, token, startDate, endDate, filter, stage, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Collateral().fetchOCByFilter(lang, token, startDate, endDate, filter, stage, branchOfficeId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_OC_BY_STATUS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_Evidence = (lang, token, orderId, option, onError, onSuccess) => dispatch => {
    api.Collateral().fetchEvidence(lang, token, orderId, option)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_EVIDENCE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const Update_Evidence = (lang, token, orderId, file, option, onError, onSuccess) => dispatch => {
    api.Collateral().uploadEvidence(lang, token, orderId, file, option)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_EVIDENCE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Evidence = (lang, token, evidenceId, orderId, option, onError, onSuccessDelete) => dispatch => {
    api.Collateral().DeleteEvidence(lang, token, evidenceId, orderId, option)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_EVIDENCE,
                payload: response.data
            })
            onSuccessDelete()
        })
        .catch(err => onError(err))
}

export const fetch_Work_Order_Detail = (lang, token, branchOfficeID, wOID, stage, onError, onSuccess) => dispatch => {
    api.Collateral().fetchWorkOrderDetail(lang, token, branchOfficeID, wOID, stage)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_WORK_ORDER_DETAIL,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Substage_Per_Order = (lang, token, orderId, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Collateral().fetchSubstagePerOrder(lang, token, orderId, branchOfficeId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_SUBSTAGE_PER_ORDER,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Substage = (lang, token, stageId, onError, onSuccess) => dispatch => {
    api.Collateral().fetchSubstage(lang, token, stageId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_SUBSTAGE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const save_SubStage = (lang, token, saveSubStageBody, onError, onSuccess) => dispatch => {
    api.Collateral().saveSubStage(lang, token, saveSubStageBody)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_SUBSTAGE_PER_ORDER_API,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_SubStage = (lang, token, subStageId, branchOfficeId, orderNumber, onError, onSuccess) => dispatch => {
    api.Collateral().deleteSubstage(lang, token, subStageId, branchOfficeId, orderNumber)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const Download_Work_Order_PDF = (lang, token, branchOfficeID, woID, onError) => dispatch => {
    api.Collateral().DownloadWorkOrderPDF(lang, token, branchOfficeID, woID)
        .then(response => {
            const data = "data:application/pdf;base64," + response.data.fileBase64
            saveAs(data, response.data.fileName)
        })
        .catch((err) => {
            onError(err)
        })
}

export const fetch_Rigths = (lang, token, onError, onSuccess) => dispatch => {
    api.Collateral().fetchRigths(lang, token)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_RIGTHS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Rigths_Per_Order = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Collateral().fetchRigthsPerOrder(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_RIGTHS_PER_ORDER,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Right = (lang, token, procedureId, procedureDocumentId, orderNumber, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Collateral().deleteRight(lang, token, procedureId, procedureDocumentId, orderNumber, branchOfficeId)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const save_Rigths = (lang, token, saveRigthsBody, onError, onSuccess) => dispatch => {
    api.Collateral().saveRigths(lang, token, saveRigthsBody)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_RIGTHS_PER_ORDER_API,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const change_State = (lang, token, changeStateBody, onError, onSuccess) => dispatch => {
    api.Collateral().changeState(lang, token, changeStateBody)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.CHANGE_STATE,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Comments = (lang, token, woID, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Collateral().fetchComments(lang, token, woID, branchOfficeId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_COMMENTS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const post_Comments = (lang, token, postCommentsBody, onError, onSuccess) => dispatch => {
    api.Collateral().postComments(lang, token, postCommentsBody)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.POST_COMMENTS_API,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const upload_Invoice = (lang, token, invoice, onError, onSuccess) => dispatch => {
    api.Collateral().uploadInvoice(lang, token, invoice)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Errors = (lang, token, woid, onError, onSuccess) => dispatch => {
    api.Collateral().fetchErrors(lang, token, woid)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ERRORS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Invoices = (lang, token, woid, onError, onSuccess) => dispatch => {
    api.Collateral().fetchInvoices(lang, token, woid)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INVOICE_HISTORY,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Comment = (lang, token, wocId, orderNumber, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Collateral().deleteComment(lang, token, wocId, orderNumber, branchOfficeId)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const download_document = (lang, token, onError, woid, onSuccess) => dispatch => {
        api.Collateral().CommentDocumentDownload(lang, token, woid)
        .then(response => {
            const data = "data:application/pdf;base64," + response.data.fileBase64
            saveAs(data, response.data.fileName)
            onSuccess();
        })
        .catch(err => onError(err))
}

export const find_Quadrant = (lang, token, branchOfficeId, orderNumber, onError, onSuccess) => dispatch => {
    api.Collateral().findQuadrant(lang, token, branchOfficeId, orderNumber)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_StatePlate = (lang, token, onError, onSuccess) => dispatch => {
    api.Collateral().fetchStatePlate(lang, token)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_STATE_PLATE,
                payload: response.data
            })
            onSuccess && onSuccess()
        })
        .catch(err => onError && onError(err))     
}

export const fetch_TypePlate = (lang, token, onError, onSuccess) => dispatch => {
    api.Collateral().fetchTypePlate(lang, token)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_TYPE_PLATE,
                payload: response.data
            })
            onSuccess && onSuccess()
        })
        .catch(err => onError && onError(err))     
}

export const fetch_WOProcedurePlate = (lang, token, woid, onError, onSuccess) => dispatch => {
    api.Collateral().fetchWOProcedurePlate(lang, token, woid)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_WOPROCEDURE_PLATE,
                payload: response.data.value
            })
            onSuccess && onSuccess()
        })
        .catch(err => onError && onError(err))     
}
